var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"lk-main-content"},[_c('div',{staticClass:"lk-main-content__navbar"},[_c('router-view',{attrs:{"name":"nav"}})],1),_c('main',{staticClass:"lk-main-content__main"},[_vm._t("default"),_c('router-view')],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }